<template>
                <div>
                    <div class="form-group row">
                        <div class="col-sm-4 col-form-label">Ansprechpartner</div>
                        <div class="col-sm-8"><input v-model="localContact.name" class="form-control"/></div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-4 col-form-label">E-Mail-Adresse(n)</div>
                        <div class="col-sm-8"><comma-separated-input v-model="localContact.email" type="email"/></div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-4 col-form-label">Telefon</div>
                        <div class="col-sm-8">
                          <comma-separated-input v-model="localContact.phone" type="tel" placeholder="+491234567"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-4 col-form-label">Organisation</div>
                        <div class="col-sm-8"><input v-model="localContact.org" class="form-control"/></div>
                    </div>
                </div>
</template>

<script>
import CommaSeparatedInput from "./CommaSeparatedInput.vue";

export default {
  props: ["contact"],
  data() {
    return {
      localContact: this.contact
    };
  },

  watch: {
    contact: {
      handler(value) {
        this.localContact = value;
      },
      deep: true
    },
    localContact: {
      handler(value) {
        this.$emit("update:contact", value);
      },
      deep: true
    }
  },
  components: {
    CommaSeparatedInput
  }
};
</script>
